"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuillLinkify = void 0;
var quill_delta_1 = __importDefault(require("quill-delta"));
var QuillLinkify = /** @class */ (function () {
    function QuillLinkify(typeList) {
        this.typeList = typeList;
    }
    QuillLinkify.prototype.searchLink = function (delta, text) {
        var _this = this;
        var isMatchedOnce = false;
        this.typeList.forEach(function (type) {
            var matches = text.match(type.regexp);
            if (!isMatchedOnce && matches && matches.length > 0) {
                isMatchedOnce = true;
                var match = matches[0];
                var split = text.split(match);
                var beforeLink = split.shift();
                if (beforeLink && beforeLink !== "") {
                    _this.searchLink(delta, beforeLink);
                }
                delta.insert(match, { link: type.normalize(match) });
                var afterLink = split.join(match);
                if (afterLink !== "") {
                    _this.searchLink(delta, afterLink);
                }
            }
        });
        if (!isMatchedOnce && text !== "\n")
            delta.insert(text);
        return delta;
    };
    QuillLinkify.prototype.linkifyCurrentLine = function (quill) {
        var sel = quill.getSelection();
        if (!sel)
            return;
        var leaf = quill.getLeaf(sel.index)[0];
        if (!leaf.text || leaf.parent.domNode.localName === 'a')
            return;
        var leafIndex = quill.getIndex(leaf);
        this.typeList.forEach(function (type) {
            var match = leaf.text.match(type.regexp);
            if (match && match.index !== undefined) {
                var delta = new quill_delta_1.default()
                    .retain(leafIndex + match.index)
                    .retain(match[0].length, { link: type.normalize(match[0]) });
                quill.updateContents(delta);
            }
        });
    };
    return QuillLinkify;
}());
exports.QuillLinkify = QuillLinkify;
